import { __assign, __awaiter, __generator } from "tslib";
import { AfterViewInit, ElementRef, OnDestroy, OnInit, } from '@angular/core';
import { select, Store } from '@ngrx/store';
import Root from '@react/components/Root';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { combineLatest, Subscription } from 'rxjs';
import * as fromAuth from '../../../auth/reducers';
import { ProfilePhoto } from '../../../react/components/ProfilePhoto';
import * as fromRoot from '../../../reducers';
import * as fromSettings from '../../../settings/reducers';
import { CognitoWrapperService } from '../../services/congito.wrapper.service';
import { FileUpload } from '../../services/s3.service';
var containerElementName = 'profilePhotoReactComponent';
var ProfilePhotoReactWrapperComponent = /** @class */ (function () {
    function ProfilePhotoReactWrapperComponent(_fileUpload, _store, _cognito) {
        this._fileUpload = _fileUpload;
        this._store = _store;
        this._cognito = _cognito;
        this._subscriptions = new Subscription();
    }
    ProfilePhotoReactWrapperComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._subscriptions.add(combineLatest([
            this._store.pipe(select(fromAuth.getClinicId)),
            this._store.pipe(select(fromAuth.getClinicOptions)),
            this._store.pipe(select(fromAuth.getUser)),
            this._store.pipe(select(fromSettings.getCurrentLanguage)),
            this._store.pipe(select(fromSettings.getLanguageTranslations)),
            this._store.pipe(select(fromRoot.getStaffProfiles)),
        ]).subscribe(function (_a) {
            var clinicToken = _a[0], clinicOptions = _a[1], user = _a[2], language = _a[3], translations = _a[4], staffProfiles = _a[5];
            _this._props = {
                clinicToken: clinicToken,
                features: clinicOptions,
                language: language,
                translations: translations,
                user: user,
                staffProfiles: staffProfiles,
            };
            _this.render();
        }));
    };
    ProfilePhotoReactWrapperComponent.prototype.ngOnDestroy = function () {
        ReactDOM.unmountComponentAtNode(this.containerRef.nativeElement);
    };
    ProfilePhotoReactWrapperComponent.prototype.ngAfterViewInit = function () {
        this.render();
    };
    ProfilePhotoReactWrapperComponent.prototype.render = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                ReactDOM.render(React.createElement(Root, __assign(__assign({}, this._props), { authService: this._cognito, dispatch: this._store.dispatch.bind(this._store), children: React.createElement(ProfilePhoto, {
                        clinicUserId: this.clinicUserId,
                        fileUploadService: this._fileUpload,
                        size: this.size,
                        staffProfiles: this._props.staffProfiles,
                    }) })), this.containerRef.nativeElement);
                return [2 /*return*/];
            });
        });
    };
    return ProfilePhotoReactWrapperComponent;
}());
export { ProfilePhotoReactWrapperComponent };
